export class ErrorUtil {
	static logError(error: any): void {
		console.log(error);
	}
}
